import { useEffect } from 'react';
import { useEditor } from '@/store/editor';

export function useKeyboardShortcuts() {
  const openCmdK = useEditor((s) => s.openCmdK);
  const closeCmdK = useEditor((s) => s.closeCmdK);
  const openGenerate = useEditor((s) => s.openGenerate);
  const closeGenerate = useEditor((s) => s.closeGenerate);
  const cmdKOpen = useEditor((s) => s.cmdKOpen);
  const generateOpen = useEditor((s) => s.generateOpen);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        openCmdK();
        return;
      }
      if (e.key === 'Escape') {
        if (cmdKOpen) closeCmdK();
        if (generateOpen) closeGenerate();
        return;
      }
      const target = e.target as HTMLElement;
      const inInput = target.matches?.('input, textarea, [contenteditable]');
      if (!inInput && e.key === 'g' && !cmdKOpen && !generateOpen) {
        openGenerate();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [cmdKOpen, generateOpen, openCmdK, closeCmdK, openGenerate, closeGenerate]);
}
